import {css} from "lit";

export const style = css`
    :host {
        --secondary-button__bg: var(--_secondary-button__bg, var(--sbkButtonBgColorSecondaryOnLightEnabled));
        --secondary-button__color: var(--_secondary-button__color, var(--sbkButtonFgColorOnLightDefault));
        --secondary-button__bg--hover: var(--_secondary-button__bg--hover, var(--sbkButtonBgColorSecondaryOnLightHover));
        --secondary-button__color--hover: var(--_secondary-button__color--hover, var(--sbkButtonSecondaryFgColorOnLightHover));
        --secondary-button__bg--active: var(--_secondary-button__bg--active, var(--sbkButtonBgColorSecondaryOnLightActive));
        --secondary-button__color--active: var(--_secondary-button__color--active, var(--sbkButtonFgColorOnDarkDefault));
        --secondary-button__bg--focus: var(--_secondary-button__bg--focus, var(--sbkButtonBgColorSecondaryOnLightFocus));
        --secondary-button__color--focus: var(--_secondary-button__color--focus, var(--sbkButtonFgColorOnLightDefault));
        --secondary-button__border-color--focus: var(--_secondary-button__border-color--focus, var(--sbkButtonBgColorSecondaryOnLightFocus));
        --secondary-button__border-color--active: var(--_secondary-button__border-color--active, var(--sbkButtonBorderOnLightActive));
        
        --copy-button__bg: var(--_copy-button__bg, var(--sbkBannerBoxColorBgColorNeutral));
    }

    .input {
        &[readonly] {
            cursor: not-allowed;
        }
    }

    .copy-link__wrapper {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: var(--sbkCoreSpacingMd);
    }

    .copy-link-button {
        position: absolute;
        right: 2px;
        display: flex;
        gap: var(--sbkButton3xs);
        align-items: center;
        outline: 2px solid transparent;
        outline-offset: var(--sbkButtonBorderGapFocus);
        border-radius: var(--sbkInputBorderRadiusDefault);
        border: none;
        cursor: pointer;
        text-decoration: none;
        fill: currentColor;
        font: var(--sbkButtonSmallLabelSm);
        padding: var(--sbkButton2xs) var(--sbkButtonMd);
        background-color: var(--copy-button__bg);
        color: var(--secondary-button__color);
    }

    @media (hover: hover) and (pointer: fine) {
        .copy-link-button:hover {
            color: var(--secondary-button__color--hover);
        }
    }

    .copy-link-button:active {
        right: 0px;
        background-color: var(--secondary-button__bg--active);
        border: var(--secondary-button__border-color--active);
        color: var(--secondary-button__color--active);
    }

    .copy-link-button:focus-visible {
        right: 0px;
        background-color: var(--secondary-button__bg--focus);
        border-color: var(--secondary-button__border-color--focus);
        color: var(--secondary-button__color--focus);
    }
`;
